import moment from "moment-timezone";
import { KOREA, US } from "utils/constant/ITME_INFO";

// export const now = moment().tz('Asia/Seoul');
// export const marketOpen = moment().tz('Asia/Seoul').set({ hour: 9, minute: 5, second: 0 });
// export const priceBatch = moment().tz('Asia/Seoul').set({ hour: 15, minute: 35, second: 0 });
// export const marketClose = moment().tz('Asia/Seoul').set({ hour: 15, minute: 50, second: 0 });
// export const currentDate = (timeZone: string) => moment.tz(new Date(), timeZone).format('YYYY-MM-DD');

interface times {
    now?: any
    marketOpen?: any
    marketClose?: any
    priceBatch?: any
    cryptoRiskBatch?: any
    cryptoOpen?: any,
    kbKoreaOrderClose?: any,
    kbKoreaOrderOpen?: any,
    kbUsStanardOrderClose?: any
    kbUsStanardOrderOpen?: any
    kbUsAfterMarketClose?: any
    kbUsPremarketOpen?: any
    kbKoreaReserveOpen?: any
    kbUsStandardBathClose?: any
    koreaStrategy5minClose?: any
}

const cacheDuration = 1000; // 1 second
let lastUpdateTime = 0;
let cachedTimes: times = {};

const updateCache = async () => {


    let koreaOpenTimeHour = 9, koreaOpenTimeMinute = 5, koreaCloseTimeHour = 15, koreaCloseTimeMinute = 30;

    let koresRes: any = null;
    if (typeof window !== 'undefined') koresRes = await fetch(`/api/delayedMarketdt?iso=KR`);
    else koresRes = await fetch(`${process.env.NEXTAUTH_URL}/api/delayedMarketdt?iso=KR`);
    const { open_time, close_time } = await koresRes.json();

    if (open_time) {
        koreaOpenTimeHour = Number(open_time.split(':')[0]) + 9
        koreaOpenTimeMinute = Number(open_time.split(':')[1]); +5
    }
    if (close_time) {
        koreaCloseTimeHour = Number(close_time.split(':')[0]) + 9
        koreaCloseTimeMinute = Number(close_time.split(':')[1]);

    }

    const now = moment().tz('Asia/Seoul');
    const cryptoOpen = moment().tz('Asia/Seoul').set({ hour: 9, minute: 0, second: 0 });
    const marketOpen = moment().tz('Asia/Seoul').set({ hour: koreaOpenTimeHour, minute: koreaOpenTimeMinute + 5, second: 0 });
    const cryptoRiskBatch = moment().tz('Asia/Seoul').set({ hour: 10, minute: 10, second: 0 });
    const marketClose = moment().tz('Asia/Seoul').set({ hour: koreaCloseTimeHour + 1, minute: 0, second: 0 });
    const koreaStrategy5minClose = moment().tz('Asia/Seoul').set({ hour: koreaCloseTimeHour + 1, minute: 20, second: 0 });
    const priceBatch = moment().tz('Asia/Seoul').set({ hour: koreaCloseTimeHour, minute: (koreaCloseTimeMinute + 5) % 60, second: 0 });

    const kbKoreaOrderOpen = moment().tz('Asia/Seoul').set({ hour: koreaOpenTimeHour, minute: koreaOpenTimeMinute, second: 0 }).subtract(35, 'minutes');
    const kbKoreaOrderClose = moment().tz('Asia/Seoul').set({ hour: koreaCloseTimeHour, minute: koreaCloseTimeMinute, second: 0 });
    const kbKoreaReserveOpen = moment().tz('Asia/Seoul').set({ hour: koreaCloseTimeHour, minute: koreaCloseTimeMinute + 10, second: 0 });



    cachedTimes = {
        now,
        marketOpen,
        cryptoOpen,
        marketClose,
        priceBatch,
        cryptoRiskBatch,
        kbKoreaOrderClose,
        kbKoreaOrderOpen,
        kbKoreaReserveOpen,
        koreaStrategy5minClose
    };

    lastUpdateTime = Date.now();
};
const updateCryptoCache = () => {
    const now = moment().tz('Asia/Seoul');
    const cryptoOpen = moment().tz('Asia/Seoul').set({ hour: 9, minute: 0, second: 0 });
    const cryptoRiskBatch = moment().tz('Asia/Seoul').set({ hour: 10, minute: 10, second: 0 });
    cachedTimes = {
        now,
        cryptoOpen,
        cryptoRiskBatch
    };

    lastUpdateTime = Date.now();
};

const updateUsCache = async () => {

    let usOpenTimeHour = 9, usOpenTimeMinute = 30, usCloseTimeHour = 16, usCloseTimeMinute = 0; // 4시 : 프리마켓 오픈, 9시30분: 정규장 오픈, 16시: 정규장 마감, 19시 50분: 애프터마켓 마감(KB)
    // let usOpenTimeHour = 4, usOpenTimeMinute = 0, usCloseTimeHour = 19, usCloseTimeMinute = 50;

    let usRes: any = null;
    if (typeof window !== 'undefined') usRes = await fetch(`/api/delayedMarketdt?iso=US`);
    else usRes = await fetch(`${process.env.NEXTAUTH_URL}/api/delayedMarketdt?iso=US`);
    const { open_time, close_time } = await usRes.json();

    if (open_time) {
        usOpenTimeHour = Number(open_time.split(':')[0])
        usOpenTimeMinute = Number(open_time.split(':')[1])
    }
    if (close_time) {
        usCloseTimeHour = Number(close_time.split(':')[0])
        usCloseTimeMinute = Number(close_time.split(':')[1])
    }

    const now = moment().tz('America/New_York');
    // const kbUsStanardOrderOpen = moment().tz('America/New_York').set({ hour: usOpenTimeHour, minute: usOpenTimeMinute, second: 0 });
    // const kbUsStanardOrderClose = moment().tz('America/New_York').set({ hour: usCloseTimeHour, minute: usCloseTimeMinute, second: 0 });

    // UTC에서 뉴욕 시간으로 변환
    // const kbUsStanardOrderOpen = moment().tz('America/New_York').set({ hour: usOpenTimeHour - 5, minute: usOpenTimeMinute - 30, second: 0 });
    // const kbUsStanardOrderClose = moment().tz('America/New_York').set({ hour: usCloseTimeHour, minute: usCloseTimeMinute, second: 0 });
    // const kbUsAfterMarketClose = moment().tz('America/New_York').set({ hour: usCloseTimeHour + 3, minute: usCloseTimeMinute + 50, second: 0 });



    const kbUsPremarketOpen = open_time
        ? moment.tz(open_time, "HH:mm", "UTC").tz("America/New_York").subtract(5, 'hours').subtract(30, 'minutes')
        : moment().tz('America/New_York').set({ hour: usOpenTimeHour - 5, minute: usOpenTimeMinute - 30, second: 0 });
    const kbUsStanardOrderOpen = open_time ?
        moment.tz(open_time, "HH:mm", "UTC").tz("America/New_York") :
        moment().tz('America/New_York').set({ hour: usOpenTimeHour, minute: usOpenTimeMinute, second: 0 });
    const kbUsStanardOrderClose = close_time
        ? moment.tz(close_time, "HH:mm", "UTC").tz("America/New_York")
        : moment().tz('America/New_York').set({ hour: usCloseTimeHour, minute: usCloseTimeMinute, second: 0 });

    const kbUsStandardBathClose = close_time ?
        moment.tz(close_time, "HH:mm", "UTC").tz("America/New_York").add(50, 'minutes')
        : moment().tz('America/New_York').set({ hour: usCloseTimeHour, minute: usCloseTimeMinute, second: 0 }).add(50, 'minutes');

    const kbUsAfterMarketClose = close_time
        ? moment.tz(close_time, "HH:mm", "UTC").tz("America/New_York").add(3, 'hours').add(50, 'minutes')
        : moment().tz('America/New_York').set({ hour: usCloseTimeHour + 3, minute: usCloseTimeMinute + 50, second: 0 });


    cachedTimes = {
        now,
        kbUsPremarketOpen,
        kbUsStanardOrderOpen,
        kbUsStanardOrderClose,
        kbUsAfterMarketClose,
        kbUsStandardBathClose
    };

    lastUpdateTime = Date.now();
}


const getCachedTimes = async () => {
    await updateCache();
    if (Date.now() - lastUpdateTime > cacheDuration) {
    }
    return cachedTimes;
};
const getCryptoCachedTimes = () => {
    updateCryptoCache();
    if (Date.now() - lastUpdateTime > cacheDuration) {
    }
    return cachedTimes;
};
const getUsCachedTimes = async () => {

    await updateUsCache();
    // if (Date.now() - lastUpdateTime > cacheDuration) {
    // }
    return cachedTimes;
};



export const getTimes = getCachedTimes;
export const getCryptoTime = getCryptoCachedTimes;
export const getUsTimes = getUsCachedTimes;
export const currentDate = (timeZone: string) => moment.tz(new Date(), timeZone).format('YYYY-MM-DD');


export const todayIsHoliday = async ({ LOC }: { LOC: string }) => {
    let isHoliday = false;
    const data = await fetch(
        `${process.env.NEXTAUTH_URL}/api/detail/holiday?${LOC === KOREA
            ? "ko=true&"
            : LOC === US
                ? "us=true&"
                : ""
        }`
    );
    const { todayIsHoliday } = await data?.json();

    isHoliday = todayIsHoliday;
    return isHoliday;
}

export const getMainTime = () => {
    const hour = moment().tz("Asia/Seoul").hour();
    const minute = moment().tz("Asia/Seoul").minute();
    // 한국 시간 기준으로 6시 30분 이후~ 오후 6시 30분 이전
    const isKoreaTime =
        (hour === 6 && minute >= 30) ||
        (hour === 18 && minute <= 30) ||
        (hour > 6 && hour < 18);

    return isKoreaTime;
}